export default __webpack_public_path__ + "static/media/auth0.beeb72b7.svg";